<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">Combined Rank Analysis</strong>
        </div>
        <div class="col-md-3">
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="actTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <div class="mb5"></div>
          <!-- <combinedRankData
            :title="alg.name"
            :combinedData="rawdata"
            :mcOptions="mcFilter"
            ref="combined"
          ></combinedRankData> -->
          <div v-if="alg.title==='ebitNwcNfa'">
            <ebitNwcNfa :isIndividual="1"></ebitNwcNfa>
          </div>
          <div v-if="alg.title==='ebitNwcNfaGtFiveHundred'">
            <ebitNwcNfaGtFiveHundred :isIndividual="1"></ebitNwcNfaGtFiveHundred>
          </div>
          <div v-if="alg.title==='ebitNwcNfaGtZero'">
            <ebitNwcNfaGtZero :isIndividual="1"></ebitNwcNfaGtZero>
          </div>
          <div v-if="alg.title==='ebitMcPeNib'">
            <ebitMcPeNib :isIndividual="1"></ebitMcPeNib>
          </div>
          <div v-if="alg.title==='ebitMcPeNiBGtFiveHundred'">
            <ebitMcPeNiBGtFiveHundred :isIndividual="1"></ebitMcPeNiBGtFiveHundred>
          </div>
          <div v-if="alg.title==='ebitMcPeNibGtZero'">
            <ebitMcPeNibGtZero :isIndividual="1"></ebitMcPeNibGtZero>
          </div>
          <div v-if="alg.title==='combinedRank'">
            <combinedRank :isIndividual="1"></combinedRank>
          </div>
          <div v-if="alg.title==='combinedRankGtFiveHundred'">
            <combinedRankGtFiveHundred :isIndividual="1"></combinedRankGtFiveHundred>
          </div>
          <div v-if="alg.title==='combinedRankGtZero'">
            <combinedRankGtZero :isIndividual="1"></combinedRankGtZero>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.scss'
import { commonMixins } from "../../assets/mixins/common.js";
import combinedRankData from "@/views/market-data/combinedRankData";
import ebitNwcNfa from "@/views/market-data/ebitNwcNfa";
import ebitNwcNfaGtFiveHundred from "@/views/market-data/ebitNwcNfaGtFiveHundred";
import ebitNwcNfaGtZero from "@/views/market-data/ebitNwcNfaGtZero";
import ebitMcPeNib from "@/views/market-data/ebitMcPeNib";
import ebitMcPeNiBGtFiveHundred from "@/views/market-data/ebitMcPeNiBGtFiveHundred";
import ebitMcPeNibGtZero from "@/views/market-data/ebitMcPeNiBGtZero";
import combinedRank from "@/views/market-data/combinedRank";
import combinedRankGtFiveHundred from "@/views/market-data/combinedRankGtFiveHundred";
import combinedRankGtZero from "@/views/market-data/combinedRankGtZero";
export default {
  components: {
    VueTabs, VTab,
    combinedRankData,
    ebitNwcNfa,
    ebitNwcNfaGtFiveHundred,
    ebitNwcNfaGtZero,
    ebitMcPeNib,
    ebitMcPeNiBGtFiveHundred,
    ebitMcPeNibGtZero,
    combinedRank,
    combinedRankGtFiveHundred,
    combinedRankGtZero
  },
  mixins: [commonMixins],
  created() {
    // this.getData();
  },
  data() {
    return {
      tabs: [
        {
          title: "ebitNwcNfa",
          name: "EBIT (NWC+NFA)",
          rawDataApi: "getAllEbitPerWorkingData"
        },
        { title: "ebitNwcNfaGtFiveHundred", name: "EBIT (Nwc + Nfa) > 500" },
        { title: "ebitNwcNfaGtZero", name: "EBIT (Nwc + Nfa) > 0" },
        { title: "ebitMcPeNib", name: "EBIT (MC+PE+NI-BD)" },
        { title: "ebitMcPeNiBGtFiveHundred", name: "EBIT (MC+PE+NI-BD) > 500" },
        { title: "ebitMcPeNibGtZero", name: "EBIT (MC+PE+NI-BD) > 0" },
        {
          title: "combinedRank",
          name: "Combined Rank",
          rawDataApi: "combinedRankOfTwentethEligibleCompany"
        },
        { title: "combinedRankGtFiveHundred", name: "Combined Rank > 500" },
        { title: "combinedRankGtZero", name: "Combined Rank > 0" }
      ],
      actTab: "",
      mcFilter: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ],
      rawdata: [],
      curdate: new Date().setDate(new Date().getDate() - 1),
      actTabApi: "getAllEbitPerWorkingData"
    };
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.actTab = tabIndex;
      this.actTabApi = this.tabs[this.actTab].rawDataApi;
      // this.getData();
    },
    getData() {
      let data = {
        my_date: this.getDate(this.curdate)
      };
      http.post(this.actTabApi, data, (error, response) => {
        if (response.length > 0) {
          this.rawdata = response;
          // console.log(myself.searchData);
        }
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/combined-rank-analysis.vue